import React, { Component } from 'react';
//import Button from 'react-bootstrap/Button'; 
import Nav from 'react-bootstrap/Nav'; 
import Navbar from 'react-bootstrap/Navbar'; 
//import NavDropdown from 'react-bootstrap/NavDropdown'; 
import Image from 'react-bootstrap/Image'; 
import Card from 'react-bootstrap/Card'; 
import { BrowserRouter, Route, Link } from "react-router-dom";
//import Form from 'react-bootstrap/Form'; 
//import FormControl from 'react-bootstrap/FormControl'; 
//import logo from './logo.svg';
import posed from 'react-pose';
import './App.css';

import Scheduler, {SchedulerData, ViewTypes, DATE_FORMAT} from 'react-big-scheduler';
//include `react-big-scheduler/lib/css/style.css` for styles, link it in html or import it here 
import 'react-big-scheduler/lib/css/style.css';
import Col from 'antd/lib/col';
import Row from 'antd/lib/row';
import Button from 'antd/lib/button';
import moment from 'moment';

const AnimateScaleRotate = posed.div({
  pressable: true,
  init: { scale: 1 },
  press: { scale: 0.8, rotate:360 }
});
const AnimateScale = posed.div({
  pressable: true,
  init: { scale: 1 },
  press: { scale: 0.8 }
});

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <NavMenu />
          {<Routing/>}
          <Footer/>
        </header>
      </div>
    );
  }
}

// https://url-zombies.glitch.me/

class Routing extends Component 
{
  render() { return <BrowserRouter>
      <div>
        <Route exact path="/" component={HomeMenu} />
        <Route path="/home" component={HomeMenu} />
        <Route path="/info" component={InfoMenu} />
        
        <Route path="/pokovci" component={Pokovci} />
        
        <Route path="/kdajkje" component={DelavniceKdajKje} />
        {/*<Route path="/mehanizmi" component={DelavniceMehanizmi} />*/}
        <Route path="/zacetni" component={DelavniceZacetni} />
        <Route path="/nadaljevalni" component={DelavniceNadaljevalni} />
        <Route path="/napredni" component={DelavniceNapredni} />

        <Route path="/onas" component={ONas} />
        <Route path="/onas-vizija" component={ONasVizija} />
        <Route path="/onas-vrednote" component={ONasVrednote} />
        <Route path="/onas-cilji" component={ONasCilji} />
        <Route path="/onas-kdosmo" component={ONasKdosmo} />
        <Route path="/onas-kontakt" component={ONasKontakt} />
      </div>
    </BrowserRouter>
  }
}

class NavMenu extends Component {
  render() {
    return <Navbar expand="sm" sticky="top">
            <Navbar.Brand href="home"><AnimateScale> <Image src={process.env.PUBLIC_URL + "/img/home_button.png"} rounded /> </AnimateScale></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav" variant="dark" expand="sd">
              <Nav className="mr-auto">
                <Nav.Link href="info"><AnimateScale>Info</AnimateScale></Nav.Link>
                <Nav.Link href="kdajkje"><AnimateScale>Tečaji</AnimateScale></Nav.Link>
                <Nav.Link href="pokovci"><AnimateScale>Pokovci</AnimateScale></Nav.Link>
                <Nav.Link href="onas"><AnimateScale>O nas</AnimateScale></Nav.Link>
                {/*}
                <NavDropdown title="O nas" id="basic-nav-dropdown">
                  <NavDropdown.Item href="onas-vizija">Vizija</NavDropdown.Item>
                  <NavDropdown.Item href="onas-vrednote">Vrednote</NavDropdown.Item>
                  <NavDropdown.Item href="onas-cilji">Cilji</NavDropdown.Item>
                  
                  <NavDropdown.Divider />
                  <NavDropdown.Item href="onas-kdosmo">Kdo smo</NavDropdown.Item>
                  <NavDropdown.Item href="onas-kontakt">Kontakt</NavDropdown.Item>
                </NavDropdown> */}
              </Nav>
              {/*<Form inline>
                <FormControl type="Išči" placeholder="Iskanje" className="mr-sm-2" />
                <Button variant="outline-success">Search</Button>
              </Form> */}
             </Navbar.Collapse>
          </Navbar>;
  }
}
//  <img src={process.env.PUBLIC_URL + '/img/home_button.png'} alt="logo" />


class HomeMenu extends Component {
  render() {
    return <div className="SubMenu"> 
            <div className="SubMenuImageStrip"> <Image className="SubMenuImage" src={process.env.PUBLIC_URL + '/img/pokovci_z_napisom.png'} alt="img" /> </div>
              <div className="SubMenuText">
                  <p><strong className="btnSelection">NEGUJMO VESELJE DO RAZISKOVANJA</strong></p>

                  <DelavniceOpcije/>
              </div>
           </div>
  }
}

class InfoMenu extends Component {
  render() {
    return <div className="SubMenu"> 
            <div className="SubMenuImageStrip"> <Image className="SubMenuImage" src={process.env.PUBLIC_URL + '/img/pokovci_z_napisom.png'} alt="img" /> </div>
              <div className="SubMenuText">
                  <p>Programi za poučevanje LEGO® EDUCATION, ki jih pri nas uporabljamo, so namenjeni otrokom med 7. in 11. letom starosti. Področje, ki ga zajemajo, je naravoslovje s pripomočki za učenje mehanizmov, robotike in programiranja. </p>
                  <p>Učenje skozi igro omogoči, da otroci z lastnimi poskusi dosežejo bistveno trajnejše pomnjenje znanja in hkrati ohranijo veselje do učenja. Gre za poseben koncept poučevanja, kjer se naučijo kritičnega razmišljanja in reševanja problemov skozi predstavitve kako stvari okoli nas delujejo. </p>
                  <p>Otroci se učijo timskega dela, saj delajo v parih, se prilagajajo drug drugemu in pogovarjajo o izzivih zadane naloge s ciljem, da se naloga izpelje. Gradivo otrokom ne pove vsega, temveč jih pripravi do tega, da se vprašajo, kaj že vedo, in raziskujejo, česar še ne razumejo. Takšne veščine bodo prišle prav otrokom kasneje v življenju. </p>
                  <p>Vpišite svojega otroka v naš program in presenečeni boste kaj vse se lahko vaš otrok nauči.</p>

                  <DelavniceOpcije/>
              </div>
           </div>
  }
}


class DelavniceKdajKjeUrnik extends Component {
  

  constructor(props) {
    super(props)
    const schedulerData = new SchedulerData(new moment().format(DATE_FORMAT), ViewTypes.Month, true, false,{
      displayWeekend: false,
      weekCellWidth: '16%', 
      schedulerWidth :'90%', 

      startResizable: false,
      eventItemPopoverEnabled: true,

      agendaResourceTableWidth: '250',
      agendaMaxEventWidth: '400',

      dayStartFrom:'08:00:00',
      dayStopTo:'17:00:00',
      
      resourceName: 'Tečaji',
      taskName: 'Naloge',
      agendaViewHeader: 'Program',

      addMorePopoverHeaderFormat: 'MMM D, YYYY dddd',
      eventItemPopoverDateFormat: 'MMM D',
      nonAgendaDayCellHeaderFormat: 'ha',
      nonAgendaOtherCellHeaderFormat: 'ddd D.M',    

      views: [
          {viewName: 'Program', viewType: ViewTypes.Month, showAgenda: true, isEventPerspective: false}/*,
          {viewName: 'Tečaji', viewType: ViewTypes.Month, showAgenda: false, isEventPerspective: false},
          {viewName: 'Naloge', viewType: ViewTypes.Month, showAgenda: false, isEventPerspective: true}, */
      ]
        
    });
    const  _resources = [
      /*{ id: 'em',
         name: 'Enostavni Mehanizmi'
      },*/  
      {  id: 'zwd',
         name: 'WeDo 2.0 Začetni'
      },
      {  id: 'nwd',
         name: 'WeDo 2.0 Nadaljevalni'
      },
      {  id: 'awd',
         name: 'WeDo 2.0 Napredni'
      }
    ]; 

    const _events = [
      {   id: 0,
          start: '2019-04-29 09:00:00',
          end: '2019-05-4 10:30:00',
          resourceId: 'zwd',
          title: 'Z0',
          subtitle: '29.4, 30.4, 3.5, 4.5',
          type: 1,
      },  
      {    id: 1,
           start: '2019-06-01 09:00:00',
           end: '2019-06-22 10:30:00',
           resourceId: 'zwd',
           title: 'Z1',
           subtitle: 'Sobote: 1.6, 7.6 (16h), 15.6, 22.6',
           type: 1,
      },
      {    id: 2,
           start: '2019-06-26 09:00:00',
           end: '2019-06-29 10:30:00',
           resourceId: 'zwd',
           title: 'Z2',
           subtitle: '26.6, 27.6, 28.6, 29.6',
           type: 1,
      },      
      {    id: 3,
           start: '2019-06-01 09:00:00',
           end: '2019-06-22 11:00:00',
           resourceId: 'nwd',
           title: 'N0',
           subtitle: 'Sobote: 1.6, 7.6 (16h), 15.6, 22.6',
           type: 2,
       },      
       {    id: 4,
            start: '2019-06-26 09:00:00',
            end: '2019-06-29 11:00:00',
            resourceId: 'nwd',
            title: 'N1',
            subtitle: '26.6, 27.6, 28.6, 29.6',
            type: 2,
       },
       {    id: 5,
            start: '2019-07-01 09:00:00',
            end: '2019-07-04 11:00:00',
            resourceId: 'nwd',
            title: 'N2',
            subtitle: '1.7, 2.7, 3.7, 4.7',
            type: 2,
       },
       {    id: 5,
            start: '2019-07-01 09:00:00',
            end: '2019-07-04 10:30:00',
            resourceId: 'zwd',
            title: 'Z2',
            subtitle: '1.7, 2.7, 3.7, 4.7',
            type: 1,
       },
       {    id: 6,
            start: '2019-07-08 09:00:00',
            end: '2019-07-11 11:00:00',
            resourceId: 'nwd',
            title: 'N3',
            subtitle: '8.7, 9.7, 10.7, 11.7',
            type: 2,
      },
      {    id: 7,
          start: '2019-07-08 09:00:00',
          end: '2019-07-11 10:30:00',
          resourceId: 'zwd',
          title: 'Z3',
          subtitle: '8.7, 9.7, 10.7, 11.7',
          type: 1,
      },
      {     id: 7,
            start: '2019-07-15 09:00:00',
            end: '2019-07-18 11:00:00',
            resourceId: 'nwd',
            title: 'N4',
            subtitle: '15.7, 16.7, 17.7, 18.7',
            type: 2,
      },
      {     id: 8,
            start: '2019-07-15 09:00:00',
            end: '2019-07-18 10:30:00',
            resourceId: 'zwd',
            title: 'Z4',
            subtitle: '15.7, 16.7, 17.7, 18.7',
            type: 1,
      },      
      {     id: 8,
            start: '2019-07-22 09:00:00',
            end: '2019-07-25 11:00:00',
            resourceId: 'nwd',
            title: 'N5',
            subtitle: '22.7, 23.7, 24.7, 25.7',
            type: 2,
      },
      {     id: 9,
            start: '2019-07-22 09:00:00',
            end: '2019-07-25 10:30:00',
            resourceId: 'zwd',
            title: 'Z5',
            subtitle: '22.7, 23.7, 24.7, 25.7',
            type: 1,
      },
      {     id: 9,
            start: '2019-07-29 09:00:00',
            end: '2019-08-01 11:00:00',
            resourceId: 'nwd',
            title: 'N6',
            subtitle: '29.7, 30.7, 31.7, 1.8',
            type: 2,
      },
      {     id: 10,
            start: '2019-07-29 09:00:00',
            end: '2019-08-01 10:30:00',
            resourceId: 'zwd',
            title: 'Z6',
            subtitle: '29.7, 30.7, 31.7, 1.8',
            type: 1,
      },
      {     id: 11,
            start: '2019-08-05 09:00:00',
            end: '2019-08-08 11:00:00',
            resourceId: 'nwd',
            title: 'N7',
            subtitle: '5.8, 6.8, 7.8, 9.8',
            type: 2,
      },
      {     id: 11,
            start: '2019-08-05 09:00:00',
            end: '2019-08-08 10:30:00',
            resourceId: 'zwd',
            title: 'Z7',
            subtitle: '29.7, 30.7, 31.7, 1.8',
            type: 1,
      },
      {     id: 12,
            start: '2019-08-12 09:00:00',
            end: '2019-08-16 11:00:00',
            resourceId: 'nwd',
            title: 'N8',
            subtitle: '12.8, 13.8, 14.8, ####, 16.8',
            type: 2,
      },
      {     id: 13,
            start: '2019-08-12 09:00:00',
            end: '2019-08-16 10:30:00',
            resourceId: 'zwd',
            title: 'Z8',
            subtitle: '12.8, 13.8, 14.8, ####, 16.8',
            type: 1,
      },      
      {     id: 14,
            start: '2019-08-19 09:00:00',
            end: '2019-08-22 11:00:00',
            resourceId: 'nwd',
            title: 'N9',
            subtitle: '19.8, 20.8, 21.8,22.8',
            type: 2,
      },
      {     id: 15,
            start: '2019-08-19 09:00:00',
            end: '2019-08-22 10:30:00',
            resourceId: 'zwd',
            title: 'Z9',
            subtitle: '19.8, 20.8, 21.8,22.8',
            type: 1,
      },      
      {     id: 16,
            start: '2019-08-26 09:00:00',
            end: '2019-08-29 11:00:00',
            resourceId: 'nwd',
            title: 'N10',
            subtitle: '26.8, 27.8, 28.8, 29.8',
            type: 2,
      },
      {     id: 17,
            start: '2019-08-12 11:00:00',
            end: '2019-08-16 13:00:00',
            resourceId: 'awd',
            title: 'A1',
            subtitle: '12.8, 13.8, 14.8, ####, 16.8',
            type: 3,
      },      
      {     id: 18,
            start: '2019-08-19 11:00:00',
            end: '2019-08-22 13:00:00',
            resourceId: 'awd',
            title: 'A2',
            subtitle: '19.8, 20.8, 21.8,22.8',
            type: 3,
      },
      {     id: 19,
            start: '2019-08-26 11:00:00',
            end: '2019-08-29 13:00:00',
            resourceId: 'awd',
            title: 'A3',
            subtitle: '26.8, 27.8, 28.8, 29.8',
            type: 3,
      },
       /*
       {    id: 4,
            start: '2019-05-08 09:00:00',
            end: '2019-05-08 10:30:00',
            resourceId: 'nwd',
            title: 'Nadaljevalni tečaj',
            subtitle: 'podnaslov',
            bgColor: '#D9D9D9FF',
            groupId: 3,
            groupName: 'Nadaljevalna skupina',
            type: 3,
            resizable: false,
            movable: false
       },
       {    id: 5,
            start: '2019-06-08 09:00:00',
            end: '2019-06-08 10:30:00',
            resourceId: 'nwd',
            title: 'Nadaljevalni tečaj',
            subtitle: 'podnaslov',
            bgColor: '#D9D9D9FF',
            groupId: 3,
            groupName: 'Nadaljevalna skupina',
            type: 3,
            resizable: false,
            movable: false
       }*/
       /*,  
       {
           id: 5,
           start: '2019-05-01 09:00:00',
           end: '2019-08-01 10:30:00',
           resourceId: 'em',
           title: 'Vsak teden od ponedeljka do četrtke.',
           rrule: 'FREQ=WEEKLY;DTSTART=20190601T013000Z;BYDAY=MO,TU,WE,TH,FR',
           groupName: 'Ponavljajoča skupina',
           bgColor: '#f759ab',
           resizable: false,
           movable: false           
       }*/
    ]
     
    moment.locale('sl');
    schedulerData.setLocaleMoment(moment);  
    schedulerData.localeMoment.locale('sl');
    schedulerData.setResources(_resources);
    schedulerData.setEvents(_events);

    //schedulerData.setEventGroupsAutoGenerated(true);

    this.state = {
      viewModel:  schedulerData,
      resources: _resources,
      events: _events
    }
  }

  componentDidMount() { 
    //this.state.viewModel.setViewType(ViewTypes.Month, true,false);
  }  

  prevClick = (schedulerData)=> {
      schedulerData.prev();
      schedulerData.setEvents(this.state.events);
      this.setState({
          viewModel: schedulerData
      })
  }
  nextClick = (schedulerData)=> {
      schedulerData.next();
      schedulerData.setEvents(this.state.events);
      this.setState({
          viewModel: schedulerData
      })
  }
  onViewChange = (schedulerData, view) => {
    schedulerData.setViewType(view.viewType, view.showAgenda, view.isEventPerspective);
    schedulerData.setEvents(this.state.events);
    this.setState({
      viewModel: schedulerData
    })
  }
  onSelectDate = (schedulerData, date) => {
    schedulerData.setDate(date);
    schedulerData.setEvents(this.state.events);
    this.setState({
      viewModel: schedulerData
    })
  }
  eventClicked = (schedulerData, event) => {
    //alert(`Dogodek: {id: ${event.id}, title: ${event.title}}`);
  };

  render() {
    return <div className="Scheduler">
                  <Scheduler  
                            schedulerData={this.state.viewModel}
                            prevClick={this.prevClick}
                            nextClick={this.nextClick}
                            onSelectDate={this.onSelectDate}
                            onViewChange={this.onViewChange}
                            eventItemClick={this.eventClicked}
                            eventItemTemplateResolver={this.eventItemTemplateResolver}
                            eventItemPopoverTemplateResolver={this.eventItemPopoverTemplateResolver}
                  /> 
            </div>
  }

  eventItemPopoverTemplateResolver = (schedulerData, eventItem, title, start, end, statusColor) => {
  return (
      // <React.Fragment>
      //     <h3>{title}</h3>
      //     <h5>{start.format("HH:mm")} - {end.format("HH:mm")}</h5>
      //     <img src="./icons8-ticket-96.png" />
      // </React.Fragment>
      <div style={{width: '300px'}}>
          <Row type="flex" align="middle">
              <Col span={2}>
                  <div className="status-dot" style={{backgroundColor: statusColor}} />
              </Col>
              <Col span={22} className="overflow-text">
                  <span className="header2-text" title={title}>{title}</span>
                  
              </Col>
              <Col>
                 <span className="header3-text" title={eventItem.subtitle}>{eventItem.subtitle}</span>
              </Col>
          </Row>
          <Row type="flex" align="middle">
              <Col span={2}>
                  <div />
              </Col>
              <Col span={22}>
                 <span className="header1-text">{start.format("HH:mm")} - {end.format("HH:mm")}</span>
              </Col>
          </Row>
          {/*<Row type="flex" align="middle">
              <Col span={2}>
                  <div />
              </Col>
             <Col span={22}>
                  <Button onClick={()=>{this.eventClicked(schedulerData, eventItem);}}>Prijavi</Button>
              </Col>
          </Row>*/}
      </div>
    );
  }
  eventItemTemplateResolver = (schedulerData, event, bgColor, isStart, isEnd, mustAddCssClass, mustBeHeight, agendaMaxEventWidth) => {
    let borderWidth = isStart ? '4' : '0';
    let borderColor =  'rgba(0,139,236,1)', backgroundColor = '#80C5F6';
    let titleText = schedulerData.behaviors.getEventTextFunc(schedulerData, event);
    if(!!event.type){
        borderColor = event.type === 1 ? 'rgba(0,139,236,1)' : (event.type == 3 ? 'rgba(245,60,43,1)' : '#999');
        backgroundColor = event.type === 1 ? '#80C5F6' : (event.type == 3 ? '#FA9E95' : '#9EFA95');
    }
    let divStyle = {borderLeft: borderWidth + 'px solid ' + borderColor, backgroundColor: backgroundColor, height: mustBeHeight };
    if(!!agendaMaxEventWidth)
        divStyle = {...divStyle, maxWidth: agendaMaxEventWidth};

    return <div key={event.id} className={mustAddCssClass} style={divStyle}>
        <span style={{marginLeft: '0px', lineHeight: `${mustBeHeight}px` }}>{titleText}</span>
    </div>;
  }
}
class DelavniceKdajKjeMehanizmi extends Component {
    render() {
    return <div className="SubMenuText">
                  <p><Link to="mehanizmi"><strong>Enostavni mehanizmi</strong></Link><Link to="kdajkje"> termini:</Link></p>
                  
                  Tečaj bo potekal v ponedeljek 29. in torek 30. aprila ter v petek 3. in soboto 4. maja 2019.
                  {/*
                  <ul>
                     <li>1. termin od 9 - 10:30h</li>
                     <li>2. termin od 11:30 - 13h</li>
                  </ul> */}
                  Cena 45€, 4 delavnice po 90 minut
            </div>
  }
}

class DelavniceKdajKjeZacetni extends Component {
  render() {
    return <div className="SubMenuText">
                  <p><Link to="zacetni"><strong>Začetni tečaji WeDo 2.0</strong></Link><Link to="kdajkje"> termini:</Link></p>
{/* 
                  Tečaj bo potekal v ponedeljek 29. in torek 30. aprila ter v petek 3. in soboto 4. maja 2019.
                  <ul>
                     <li>1. termin od 9 - 10:30h</li>
                     <li>2. termin od 11:30 - 13h</li>
                  </ul> */}
                  Cena 45€, 4 delavnice po 90 minut
            </div>
  }
}
class DelavniceKdajKjeNadaljevalni extends Component {
  render() {
    return <div className="SubMenuText">
                  <p><Link to="nadaljevalni"><strong>Nadaljevalni tečaji WeDo 2.0</strong></Link><Link to="kdajkje"> termini:</Link></p>
 {/*              <ul>
                    <li>Še ni določeno</li>
                  </ul> */}
                  Cena 50€, 4 delavnice po 120 minut
            </div>
  }
}
class DelavniceKdajKjeNapredni extends Component {
  render() {
    return <div className="SubMenuText">
                  <p><Link to="napredni"><strong>Napredni tečaji WeDo 2.0</strong></Link><Link to="kdajkje"> termini:</Link></p>
 {/*              <ul>
                    <li>Še ni določeno</li>
                  </ul> */}
                  Cena 50€, 4 delavnice po 120 minut
            </div>
  }
}

class DelavniceKdajKje extends Component {
  render() {
    return <div className="SubMenu"> 
            <div className="SubMenuImageStrip"> <Image className="SubMenuImage" src={process.env.PUBLIC_URL + '/img/kocke_vodoravno.png'} alt="img" /> </div>
              <DelavniceKdajKjeUrnik/>
             {/*} <DelavniceKdajKjeMehanizmi/> */}
              <DelavniceKdajKjeZacetni/>
              <DelavniceKdajKjeNadaljevalni/>
              <DelavniceKdajKjeNapredni/>
              <DelavniceOpcije/>
           </div>
  }
}
/*
class DelavniceMehanizmi extends Component {
  render() {
    return <div className="SubMenu"> 
            <div className="SubMenuImageStrip"> <Image className="SubMenuImage" src={process.env.PUBLIC_URL + ''} alt="img" /> </div>
              <div className="SubMenuText">
                  <p><strong>ENOSTAVNI MEHANIZMI <br/> LEGO® Education</strong></p>
                  <p>Otroci se bodo preizkusili v vlogi mladih znanstvenikov, oblikovalcev in inženirjev ter raziskali delovanje preprostih in sestavljenih strojev, ki jih vidijo v vsakdanjem življenju.</p>
                  <ul>
                    <li>Tečaj je namenjen otrokom od 7-10 let starosti </li>
                    <li>Otroci se spoznajo z osnovami delovanja preprostih mehanizmov: zobnikov koles, osi, vzvodov in škripcev.</li>
                    <li>Osvajajo temelje konstruiranja.</li>
                    <li>Učijo skozi opazovanje, sklepanje, napovedovanje, razmišljanje in kritično mišljenje.</li>
                    <li>Sodelujejo v parih, kar omogoča komunikacijo o idejah in timsko delo.</li>
                    <li>Trajanje ene delavnice je 90 minut.</li>
                    <li>Za tečaj predhodno znanje ni potrebno. </li>
                    <li>Zajema tudi osnove WeDo 2.0 </li>
                  </ul>
                  <DelavniceKdajKjeMehanizmi/>
                  <DelavniceOpcije/>
              </div>
           </div>
  }
} */
class DelavniceZacetni extends Component {
  render() {
    return <div className="SubMenu"> 
            <div className="SubMenuImageStrip"> <Image className="SubMenuImage" src={process.env.PUBLIC_URL + '/img/strip_polz.png'} alt="img" /> </div>
              <div className="SubMenuText">
                  <p><strong>ZAČETNI TEČAJ <br/>ROBOTIKA IN PROGRAMIRANJE SKOZI IGRO z LEGO® WeDo 2.0</strong></p>
                  <p>Skozi simpatične znanstvene projekte, ki obravnavajo realne in relevantne primere bodo otroci doživeli kako znanost oživi.</p>
                  <ul>
                    <li>Tečaj je namenjen otrokom od 7-11 let starosti</li>
                    <li>Otroci se na vsaki delavnici najprej spoznajo z delovanjem enostavnih mehanizmov: zobnikov, koles in osi, vzvodov in škripcev.</li>
                    <li>Osvajajo temelje konstruiranja.</li>
                    <li>Preidejo na WeDo 2.0 komplet, kjer spoznavajo in sestavljajo enostavne modele robotov. </li> 
                    <li>Ob tem razvijajo sposobnost prostorske predstave in ustvarjalnost.</li> 
                    <li>Učijo se osnov programiranja s pomočjo vizualnih blokov, kar je enostavno za razumevanje in otroke zelo motivira.</li>
                    <li>Naučijo se programsko upravljati robota. Pri tem eksperimentirajo in samostojno rešujejo probleme.</li>
                    <li>Sodelujejo v dvojicah in skupini, kar pripomore k učenju socialnih veščin.</li>
                    <li>Spoznavajo različne oblike uporabe računalniških tehnologij.</li>
                    <li>Trajanje ene delavnice je 90 minut.</li>
                    <li>Za začetni tečaj predhodno znanje ni potrebno.</li> 
                  </ul>
                  <DelavniceKdajKjeZacetni/>
                  <DelavniceOpcije/>
              </div>
           </div>
  }
}
class DelavniceNadaljevalni extends Component {
  render() {
    return <div className="SubMenu"> 
            <div className="SubMenuImageStrip"> <Image className="SubMenuImage" src={process.env.PUBLIC_URL + '/img/strip_veternica.png'} alt="img" /> </div>
              <div className="SubMenuText">
                  <p><strong>NADALJEVALNI TEČAJI<br/>ROBOTIKA IN PROGRAMIRANJE SKOZI IGRO z LEGO® WeDo 2.0</strong></p>
                  <p>Spodbudite otrokovo radovednost in izboljšajte njihove sposobnosti pri naravoslovju, tehniki, tehnologiji in programiranju.</p>
                  <ul>
                    <li>Nadaljevalni tečaj je namenjen otrokom od 8-11 let starosti.</li>
                    <li>Otroci spoznavajo in sestavljajo zahtevnejše modele robotov in se srečujejo z bolj kompleksnimi konstrukcijskimi problemi.</li>
                    <li>Projekti so vodeni korak po korak.</li>
                    <li>Programiranja poteka s pomočjo vizualnih blokov, programski algoritmi pa so na nadaljevalnem tečaju naprednejše težavnostne stopnje.</li>
                    <li>Učijo se programsko upravljati robota. Pri tem eksperimentirajo in samostojno rešujejo probleme.</li>
                    <li>Sodelujejo v dvojicah in skupini, kar pripomore k učenju socialnih veščin.</li>
                    <li>Spoznavajo različne oblike uporabe računalniških tehnologij.</li>
                    <li>Trajanje ene delavnice je 2 ure.</li>
                    <li>Priporočljiva je predhodna udeležba na začetnem tečaju.</li>
                    <li>Tečaji obsegajo 8 projektov po 120 minut, med tečajem izdelajo 4 projekte.</li>
                  </ul>

                  <p>Več o edukativnem setu kock WeDo 2.0 si lahko pogledate na 
                  <a href="https://education.lego.com/en-us/elementary/intro/wedo2" target = "_blank" rel="noopener noreferrer"><strong> LEGO Education</strong></a><br/>  </p>
                  <DelavniceKdajKjeNadaljevalni/>
                  <DelavniceOpcije/>
              </div>
           </div>
  }
}

class DelavniceNapredni extends Component {
  render() {
    return <div className="SubMenu"> 
            <div className="SubMenuImageStrip"> <Image className="SubMenuImage" src={process.env.PUBLIC_URL + '/img/kocke_vodoravno.png'} alt="img" /> </div>
              <div className="SubMenuText">
                  <p><strong>NAPREDNI TEČAJ <br/>ROBOTIKA IN PROGRAMIRANJE SKOZI IGRO z LEGO® WeDo 2.0</strong></p>
                  <p>Spodbudite otrokovo radovednost in izboljšajte njihove sposobnosti pri naravoslovju, tehniki, tehnologiji in programiranju.</p>
                  <ul>
                    <li>Napredni tečaj je namenjen otrokom od 9-12 let starosti.</li>
                    <li>Projekti namenoma ne ponujajo postopnega vodenja, temveč uvodne informacije in začetne točke kako na osnovi teh graditi naprej.</li>
                    <li>Programiranja poteka s pomočjo vizualnih blokov, programski algoritmi so na nadaljevalnem tečaju naprednejše težavnostne stopnje.</li>
                    <li>Narediti morajo program s katerm upravljajo robota. Pri tem samostojno rešujejo probleme.</li>
                    <li>Sodelujejo v dvojicah in skupini, kar pripomore k učenju socialnih veščin.</li>
                    <li>Spoznavajo različne oblike uporabe računalniških tehnologij.</li>
                    <li>Trajanje ene delavnice je 2 ure.</li>
                    <li>Priporočljiva je predhodna udeležba na nadaljevalnih tečajih.</li>
                    <li>Tečaji obsegajo 8 projektov po 120 minut, med tečajem izdelajo minimalno 2 projekta.</li>
                  </ul>
                  <DelavniceKdajKjeNapredni/>
                  <DelavniceOpcije/>
              </div>
           </div>
  }
}



class Pokovci extends Component {
  render() {
    return  <div className="SubMenu"> 
              <div className="SubMenuText"> 
                 <strong>KDO SO MALI POKOVCI?</strong><br/>
<p>
  V inštitutu Pametno jajce živi druščina kljunastih znanstvenikov. Tam radovedneži nenehno nekaj raziskujejo, brskajo in valijo presneto dobre ideje. Nato se prelevijo v prave mojstre, pljunejo v svoja pernata krilca ter začnejo graditi stroje in robote, sestavljajo, razstavljajo, montirajo in programirajo. Ko njihove mojstrovine oživijo pa z velikim apetitom ves večer zasluženo razhroščujejo. Pridruži se jim tudi ti, saj se naši Mali pokovci znajo ob vsem tem znanstvenem garanju tudi dobro zabavati.
</p><br/>

<strong>PREDZGODBA: NEVERJETNO BRIHTNA KOKOŠ MAJDA - MATI MALIH POKOVCEV</strong>

<p>
Medtem ko so druge kure stikale za črvi, čistile svoje perje in kljuvale kmetove škornje, je naša Majda vestno čakala pri domačem plotu na prihod potujoče knjižnice. Dobrohotna knjižničarka Greta, ki je bila vesela, da še kdo sploh danes kaj bere, ji je z veseljem sposojala vse debelejše knjige. Celo zamudnine ji ni hotela računati. No, to je bila tudi praktična odločitev, saj Majda ni imela nič denarja. 
V nasprotju s knjižničarko pa kmet ni bil nič kaj vesel. Druge kure so mu ob glasnem kokodajsanju pridno valile jajca, Majda za to ni pokazala nobenega interesa. Domačega petelina je vztrajno ignorirala, potem pa mu je nekega dne še s tisto veliko bukvo SSKJ priprla glavo in mu poškodovala center za ravnotežje. Od takrat se je je petelin izogibal v velikem ukrivljenem loku. 
Majda je slabo skrbela za svojo prehrano, tako je bila vsa grintava in kot takšna tudi za v juho neprimerna - ne dovolj mastna. Nekega dne, ko je knjižničarka opevala njeno izobraženost, ji je kmet zabrusil, naj si jo kar s sabo vzame, saj on od nje nima nobene koristi. Tako je presrečna Majda odpotovala z rajskim avtobusom polnim zanimivih knjig. 
Knjižničarka Greta je neverjetno brihtno kokoš Majdo podarila za rojstni dan svojemu fantu znanstveniku Jožefu, ki je delal na inštitutu Pametno jajce in tako se je počasi začela zgodba Malih Pokovcev. 
(Še prej pa sledi: Kako je znanstvenik Jožef na portalu 'Ljubezenske zmenkarije' iskal primernega petelina za svojo putko.)
</p>


           </div>
           </div>
  }
}
class ONas extends Component {
  render() {
    return <div className="SubMenu"> 
            <ONasVizija/>
            <ONasVrednote/>
            <ONasCilji/>
            <ONasKdosmo/>
            <ONasKontakt/>
           </div>
  }
}
class ONasVizija extends Component {
  render() {
    return  <div className="SubMenuText">
            <strong>VIZIJA</strong><br/>
                 Naša vizija je, da pri otrocih z učenjem skozi igro ohranimo domišljijo, vzpodbujamo ustvarjalnost in praktično usvajanje znanja. 
                 Kocke so učikovit medij za prenos znanja saj delujejo več nivojsko, kot fizična prezentacija gradnika in kot mentalna metafora za "črno skrinjo" transformacije informacij. 
                 Naučiti mlade možgane 'digitalnega razmišljanja', je nekaj, kar za vedno ostane in jim bo v prihodnosti dalo prednost pred tistimi, ki tega razmišljanja ne osvojijo v mladih letih. 
                 Skozi igro kodiranja in kreacije se pri otroku pospeši razvoj njihovega osebnega funkcionalnega jezika, opremijo se z realnimi veščinami in povečajo samo-spoštovanje.   
                 Otrok osvoji koncept kaj so to podatki, kako vhodne podatke spremeni s 'črno' kocko ter dobi rezulat - izhodni podatek. <br/>
                 <br/>
                 Argumenti, ki so mogoče najbolj razumljivi in merljivi, da je trg dela že danes podhranjen, v prihodnosti pa bo potreba po informacijsko-tehnoloških znanjih še veliko večja. 
                 Hitrost s katero se razvija področje je po ocenah sedemkrat večja od ponudbe. Tehnologija in računalniki so jedro in gonilna sila ekonomije. 
                 Digitalna pismenost je postala dejstvo tudi za ne-tehnična dela. Po zadnji agendi Evropske komisije 90% vseh služb potrebuje poznavanje osnov informatike. 
                 Odločitev, da pripravimo naše najmlajše za prihodnost, izhaja iz dejstev, da v našem širšem lokalnem okolju otroci nimajo možnosti se seznaniti z temi osnovami. 
                 Nacionalni izobraževalni sistemi to praznino vlečejo do konca osnovne šole. Kar je za kompetence, ki jih trg zahteva, popolnoma neprimerno. <br/>
                 <br/>
                 Digitalna pismenosti ni samo znanje kako programirati, temveč izučiti generacijo kako uporabljati tehnologijo, računalnike, internet, blockchain, umetno inteligenco na boljši, pametnejši način. 
                 V svetu kjer si življenja brez tehnologije ne znamo več predstavljati, postaja programiranje bazično znanje in digitalna pismenost se vse pogosteje pojavlja v isti kategoriji kot pisanje, branje in računanje.
           </div>
  }
}
class ONasVrednote extends Component {
  render() {
    return <div className="SubMenuText">
            <strong>VREDNOTE</strong><br/>
               Naše vrednote so znanje, igra, domišljija, ustvarjalnost in akcija. <br/><br/>
               <Image src={process.env.PUBLIC_URL + '/img/ptic_googles.png '} alt="img" height="60" />  
               Želimo nuditi možnost učenja za vse otroke, zato del sredstev namenimo v interni sklad <strong>Mali Pokovci</strong>, 
                s katerim omogočimo obiske tečajev socialno ogroženim otrokom.<br/>
               <br/>
               Delujemo po principih Fair Data Society in zagovarjamo stališče, da ima vsak posameznik pravico do zasebnosti in anonimnosti in da so osebni podatki nedotakljivi. 
               Ta stran ne vsebuje nobenih piškotov in ne zbiramo nobenih podatkov. <br/> 
           </div>
  }
}
class ONasCilji extends Component {
  render() {
    return <div className="SubMenuText">
            <strong>CILJI</strong><br/>
            Naš cilj je ponuditi otrokom kakovostne pripomočke za učenje, ustvarjalno okolje in vzpodbudne mentorje. <br/><br/>
            <ul>Začeli smo s ustaljenimi tečaji, v nadaljevanju želimo ponuditi še naslednje veščine: 
              <li>Kreativno kodiranje</li>
              <li>Kaj pa igre</li>
              <li>Kritično razmišljanje</li>
              <li>Sistemsko razmišljanje</li>
              <li>Kače, kuščarji in funkcije</li>
              <li>Modeliranje mrež</li>
              <li>Veriženje kock</li>
            </ul> 
            <br/>
            <strong>POKOVC</strong> <Image src={process.env.PUBLIC_URL + '/img/ptic_gate_kocka.png '} alt="img" height="60" /> <br/>
            Vsak opravljen tečaj digitalno podpišemo in izdamo "Pokovca" <br/> 
            Pokovc morda izgleda kot slika, a skriva veliko več. Je značka in je potrdilo podpisano z neizpodbitnim digitalnim zapisom, da je bil tečaj opravljen.
            Sčasoma si bodo nabrali veliko značk, s katerimi bodo lahko v prihodnosti dokazali, da imajo določene mikro veščine. 
            <br/>
            {/*po standardu <a href="https://openbadges.org/" target = "_blank">Mozzila Open Badge</a>,*/}
           </div>
  }
}
class ONasKdosmo extends Component {
  render() {
    return <div className="SubMenu2">
            <div className="SubMenuText">
            <strong>KDO SMO</strong><br/>
               Mali pokovci so izobraževalni del podjetja Media ATLAS s sedežem v Sevnici.
           </div>
           <div  style={{display: 'flex', flexDirection: 'row'}}>
           <Card style={{ width: '28rem', background:"#00000000", flex: 1 }}>
              <Card.Img variant="top" src={process.env.PUBLIC_URL + '/img/gipsy.png'} />
              <Card.Body>
                <Card.Title>Sanja Lončar</Card.Title>
                <Card.Text>
                Ljubiteljica barv in čopičev, sama svoja mojstrica, prepričana, da lahko ustvarjalnost naredi vsako učenje zabavno. S popotništvom, ki odpira ventile, za vedno spremenjena. Zadovoljna mati treh otrok, ki išče dodatne načine za kravžljanje njihovih možganov. Socialna delavka po naravi in izobrazbi.
                </Card.Text>
                {/*<Button variant="primary">Go somewhere</Button>*/}
              </Card.Body>
            </Card>

            <Card style={{ width: '28rem', background:"#00000000", flex: 1 }}>
              <Card.Img variant="top" src={process.env.PUBLIC_URL + '/img/motorist1.png'} />
              <Card.Body>
                <Card.Title>Tadej Fius</Card.Title>
                <Card.Text>
                  Programer. Inovator. Ustvarjalec. Podjetnik. Cypherpunk. <br/><br/>
                  
                  <a href="https://fairdatasociety.org/" target = "_blank" rel="noopener noreferrer">Fair Data Society</a><br/>
                  <a href="https://www.mediaatlas.si" target = "_blank" rel="noopener noreferrer"> www.mediaatlas.si</a><br/>
                  
                </Card.Text>
                {/*<Button variant="primary">Go somewhere</Button>*/}
              </Card.Body>
            </Card>            
            </div>
           </div>
  }
}
class ONasKontakt extends Component {
  render() {
    return <div className="SubMenu2">
            <div className="SubMenuText">

          <strong>KONTAKT</strong><br/> 

          Prijave zbiramo na 040847728 (Sanja) <br/>
          Media ATLAS, Mali pokovci <br/>
          Kajuhova 11 <br/>
          8290 Sevnica <br/>
          Slovenija <br/>
          mail: info@mediaatlas.si <br/><br/><br/>

          <strong>O PODJETJU</strong><br/> 
          Media ATLAS 
          Tadej Fius s.p. <br/>
          +386 40 42 33 99 gsm <br/> <br/>

          Račun: SI56 0237 9025 7499 425 pri NLB <br/>
          Matična številka: 3393933000 <br/>
          Davčna števila: 28928440  <br/>
          Šifra podrazreda po SDD: 62.010  <br/>
          Šifra SKIS: 14100 <br/>
          
          <a href="https://www.mediaatlas.si" target = "_blank" rel="noopener noreferrer"> www.mediaatlas.si </a>
           </div>
          </div>
  }
}


class DelavniceOpcije extends Component {
  render() {
    return <div> 
                  <p className="btnSelection">Za več informacij pokličite 040847728</p>  
                  <div className="btnSelection">
                   {/* <AnimateScaleRotate><Link to="mehanizmi">   <button className="btnGears"> <img className="bntGearsImg" src={process.env.PUBLIC_URL + "/img/zobnik1.png"} rounded="true" alt=""/> Enostavni Mehanizmi</button> </Link> </AnimateScaleRotate> */}
                    <AnimateScaleRotate><Link to="zacetni">     <button className="btnGears"> <img className="bntGearsImg" src={process.env.PUBLIC_URL + "/img/zobnik1.png"} rounded="true" alt=""/> Začetni - WeDo 2.0</button> </Link> </AnimateScaleRotate> 
                    <AnimateScaleRotate><Link to="nadaljevalni"><button className="btnGears"> <img className="bntGearsImg" src={process.env.PUBLIC_URL + "/img/zobnik1.png"} rounded="true" alt=""/> Nadaljevalni WeDo 2.0</button> </Link> </AnimateScaleRotate>
                    <AnimateScaleRotate><Link to="napredni"><button className="btnGears"> <img className="bntGearsImg" src={process.env.PUBLIC_URL + "/img/zobnik1.png"} rounded="true" alt=""/> Napredni WeDo 2.0</button> </Link> </AnimateScaleRotate>
                  </div>
          </div>
  }
}



class Footer extends Component {
  render() {
    return <div> 
               <p className="footerInfo"> 
               Stran uporablja <a href="https://opendyslexic.org/" target = "_blank">OpenDyslexic</a> pisavo.<br/>
               Ime LEGO je zaščitena blagovna znamka podjetja LEGO. © 2017. The name LEGO is a registered trademark of the LEGO Company. Copyright 2017. <br/>
               Pokovc, Pokovci in Mali Pokovci (C) 2018 MediaAtlas <br/>
               </p>
          </div>
  }
}



export default App;
/*
Otroci osvajajo temelje konstruiranja in osnovei delovanja prepostih mehanizmov: zobnikov koles, osi, vzvodov in škripcev. Trajanje: 4x90 minut, 7-9 let mladosti. 
*/ 